import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

import { Button } from '@/components/Button/Button'
import { Card } from '@/components/Card'
import { RouterPath } from '@/models/enums'
import { activityTrackingService } from '@/services/ActivityTrackingService'

type MembershipCardProps = {
  className?: string
}

export const MembershipCard: FC<MembershipCardProps> = ({ className = '' }) => {
  const { t } = useTranslation('membership-card')
  const navigate = useNavigate()
  const handleClick = () => {
    activityTrackingService.trackBookButtonClick('membership_card')
    navigate(`/${RouterPath.Hub}/${RouterPath.MakeAppointment}`)
  }

  return (
    <Card title={t('title')} className={twMerge('col-span-2 md:col-span-1', className)}>
      <p>{t('description')}</p>
      <p>{t('description_2')}</p>
      <div className="mt-4">
        <Button className="ml-auto h-auto w-[114px] uppercase" onClick={handleClick}>
          {t('action_button')}
        </Button>
      </div>
    </Card>
  )
}
